import { gql } from "graphql-tag";
import {
  CartItemFragment,
  UserProfileFragment,
  PreOrderFragment,
  OrderFragment,
  SessionFragment,
} from "./fragments";

export const getCodeMutation = gql`
  mutation getCode($phone: String!) {
    getCode(phone: $phone)
  }
`;

export const updateProfileMutation = gql`
  mutation UpdateProfile($update: UpdateProfile!) {
    updateProfile(update: $update) {
      ...UserProfileFragment
    }
  }
  ${UserProfileFragment}
`;

export const connectOAuthMutation = gql`
  mutation connectOAuth($oauthProvider: OAuthProvider!, $externalID: String!) {
    connectOAuth(oauthProvider: $oauthProvider, externalID: $externalID)
  }
`;

export const loginMutation = gql`
  mutation login($code: String!, $phone: String!) {
    login(code: $code, phone: $phone) {
      ...SessionFragment
    }
  }
  ${SessionFragment}
`;

export const loginOAuthMutation = gql`
  mutation loginOAuth($oauthProvider: OAuthProvider!, $code: String!) {
    loginOAuth(oauthProvider: $oauthProvider, code: $code) {
      oauthUser {
        id {
          external
          provider
        }
        name
        phone
        email
      }
      session {
        ...SessionFragment
      }
    }
  }
  ${SessionFragment}
`;

export const ReguestCallbackMutation = gql`
  mutation RequestCallback($phone: String!, $name: String!) {
    requestCallback(phone: $phone, name: $name) {
      enableTime
    }
  }
`;

export const ApplyLoyaltyProgramMutation = gql`
  mutation ApplyLoyaltyProgram($regionID: ID!, $loyalty: LoyaltyInput) {
    applyLoyaltyProgram(regionID: $regionID, loyalty: $loyalty) {
      ...PreOrderFragment
    }
  }
  ${PreOrderFragment}
`;

export const UpdateCartMutation = gql`
  mutation UpdateCartMutation($regionID: ID!, $items: [CartItemInput!]!) {
    updateCart(regionID: $regionID, items: $items) {
      groups {
        items {
          ...CartItemFragment
        }
      }
    }
  }
  ${CartItemFragment}
`;

export const ResetCartMutation = gql`
  mutation ResetCartMutation($regionID: ID!) {
    clearCart(regionID: $regionID) {
      groups {
        items {
          ...CartItemFragment
        }
      }
    }
  }
  ${CartItemFragment}
`;

export const AddPromotedEmailMutation = gql`
  mutation AddPromotedEmailMutation($input: AddPromotedEmailInput!) {
    addPromotedEmail(input: $input) {
      ...UserProfileFragment
    }
  }
  ${UserProfileFragment}
`;

export const UpdatePreOrderMutation = gql`
  mutation UpdatePreOrderMutation($input: PreOrderInput!) {
    updatePreOrder(input: $input) {
      ...PreOrderFragment
    }
  }
  ${PreOrderFragment}
`;

export const ResetPreOrderMutation = gql`
  mutation ResetPreOrderMutation($regionID: ID!) {
    clearPreOrder(regionID: $regionID) {
      ...PreOrderFragment
    }
  }
  ${PreOrderFragment}
`;

export const SaveOrderMutation = gql`
  mutation SaveOrderMutation($regionID: ID!) {
    saveOrder(regionID: $regionID) {
      ...OrderFragment
    }
  }
  ${OrderFragment}
`;

export const CancelOrderMutation = gql`
  mutation cancelOrder(
    $regionID: ID!
    $orderID: ID!
    $returnItemsToBasket: Boolean!
  ) {
    cancelOrder(
      regionID: $regionID
      orderID: $orderID
      returnItemsToBasket: $returnItemsToBasket
    )
  }
`;

export const registerMutation = gql`
  mutation registerClient($data: RegisterData!) {
    registerClient(data: $data) {
      ...SessionFragment
    }
  }
  ${SessionFragment}
`;

export const logoutMutation = gql`
  mutation logout {
    logout
  }
`;

export const updateFavorites = gql`
  mutation updateFavoriteProducts(
    $mode: UpdateFavoriteProductsMode
    $productID: ID!
    $regionID: ID!
  ) {
    updateFavoriteProducts(
      mode: $mode
      productID: $productID
      regionID: $regionID
    ) {
      items
      total
    }
  }
`;

export const createReviewMutation = gql`
  mutation createReview($rating: Int!, $productID: ID!, $message: String!) {
    createReview(params: { ID: $productID, message: $message, rating: $rating })
  }
`;

export const setDrugNotifyMutation = gql`
  mutation setDrugNotify($params: SetDrugNotifyParams!) {
    setDrugNotify(params: $params)
  }
`;

export const refreshTokenMutation = gql`
  mutation refreshToken($refreshToken: String!) {
    refreshToken(refreshToken: $refreshToken) {
      accessToken
      refreshToken
    }
  }
`;
